// used to override related tailwind classNames when merging
import {twMerge} from 'tailwind-merge';

// reexporting for quick import
export const cn = twMerge;
